module.exports = __webpack_public_path__ + "img/logo-spotify.e359ad39.svg";